import React from 'react';
import {
  makeStyles,
  Container,
  Grid,
  Typography,
  Box,
  Button,
} from '@material-ui/core';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import PhoneIphoneIcon from '@material-ui/icons/PhoneIphone';
import DateRangeIcon from '@material-ui/icons/DateRange';
import MapIcon from '@material-ui/icons/Map';
import MoodIcon from '@material-ui/icons/Mood';
import { Router } from 'config/i18n';

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    paddingTop: theme.spacing(13),
    marginBottom: theme.spacing(15),
    [theme.breakpoints.up('lg')]: {
      marginBottom: theme.spacing(22),
      paddingTop: theme.spacing(18),
    },
    [theme.breakpoints.only('sm')]: {
      paddingTop: theme.spacing(8),
      marginBottom: theme.spacing(12),
    },
  },
  title: {
    fontSize: theme.typography.pxToRem(22),
    marginBottom: theme.spacing(2),
    fontFamily: theme.typography.fontFamilySecondary,
    fontWeight: 'bold',
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      fontSize: theme.typography.pxToRem(36),
      marginBottom: theme.spacing(4),
    },
  },
  subTitle: {
    color: theme.palette.grey[400],
    fontSize: theme.typography.pxToRem(14),
    marginBottom: theme.spacing(2),
    textAlign: 'center',
    lineHeight: theme.typography.pxToRem(30),
    [theme.breakpoints.up('md')]: {
      fontSize: theme.typography.pxToRem(16),
      marginBottom: theme.spacing(8),
    },
  },
  txtGrid: {
    marginTop: theme.spacing(1),
    [theme.breakpoints.up('md')]: {
      marginTop: theme.spacing(4),
    },
    [theme.breakpoints.up('lg')]: {
      order: 2,
      marginTop: 0,
    },
  },
  itemsContainer: {
    padding: theme.spacing(0),
    width: 'auto',
    marginLeft: 0,
    textAlign: 'center',
    [theme.breakpoints.up('lg')]: {
      padding: theme.spacing(0, 0, 4.5),
    },
  },
  itemIcn: {
    '& .MuiSvgIcon-root': {
      width: theme.spacing(6),
      height: theme.spacing(6),
      color: theme.palette.primary.dark,
      [theme.breakpoints.only('sm')]: {
        width: theme.spacing(4),
        height: theme.spacing(4),
      },
    },
  },
  itemDesc: {
    letterSpacing: theme.typography.pxToRem(0.5),
    lineHeight: theme.typography.pxToRem(24),
    marginTop: theme.spacing(1.5),
    fontSize: theme.typography.pxToRem(16),
    '& a': {
      color: theme.palette.secondary.main,
      fontWeight: 'bold',
      textDecoration: 'none',
    },
  },
  getStartedBox: {
    marginTop: theme.spacing(4),
    textAlign: 'center',
    [theme.breakpoints.only('sm')]: {
      marginTop: theme.spacing(6),
    },
  },
  getStarted: {
    boxShadow: 'none',
  },
}));

const IncreaseProfit = ({ i18n }) => {
  const classes = useStyles();
  const items = i18n('fe_increase_profit_component:items', {
    returnObjects: true,
  });
  const itemsIcn = [
    <MonetizationOnIcon />,
    <PeopleAltIcon />,
    <PhoneIphoneIcon />,
    <DateRangeIcon />,
    <MapIcon />,
    <MoodIcon />,
  ];
  const handleBtnClick = () => {
    Router.push('/user/vehicles');
  };
  return (
    <>
      <Container maxWidth="xl" classes={{ root: classes.mainContainer }}>
        <Grid
          container
          justify="center"
          alignItems="center"
          spacing={2}
        >
          <Grid item xs={12} lg={8}>
            <Typography variant="h2" classes={{ root: classes.title }}>
              {i18n('fe_increase_profit_component:title')}
            </Typography>
            <Typography variant="h3" classes={{ root: classes.subTitle }}>
              {i18n('fe_increase_profit_component:sub_title')}
            </Typography>
            <Grid
              container
              justify="center"
              alignItems="flex-start"
              spacing={6}
            >
              {items.map((item, index) => (
                <Grid item xs={12} md={4} classes={{ root: classes.txtGrid }}>
                  <Box className={classes.itemsContainer} key={item.desc}>
                    <Box className={classes.itemIcn}>{itemsIcn[index]}</Box>
                    <Typography classes={{ root: classes.itemDesc }}>
                      {item.desc}
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
        <Box className={classes.getStartedBox}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleBtnClick}
            classes={{ root: classes.getStarted }}
          >
            {i18n('fe_commercial_host_banner_shared:get_started')}
          </Button>
        </Box>
      </Container>
    </>
  );
};

export default IncreaseProfit;
